export default __webpack_public_path__ + "static/media/home.ae89748a.png";